import { memo, useState, useEffect } from "react";

export const CameraViewpoint = memo(({ viewpoint, onSelect, isSelected, getFileUrl }) => {
    const [thumbnailUrl, setThumbnailUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        let objectUrl = null;

        const loadThumbnail = async () => {
            if (viewpoint.thumbnailToken && isMounted) {
                const url = await getFileUrl(viewpoint.thumbnailToken);
                if (isMounted) {
                    objectUrl = url;
                    setThumbnailUrl(url);
                    setLoading(false);
                }
            } else if (isMounted) {
                setLoading(false);
            }
        };

        loadThumbnail();

        return () => {
            isMounted = false;
            if (objectUrl && objectUrl.startsWith("blob:")) {
                window.URL.revokeObjectURL(objectUrl);
            }
        };
    }, [viewpoint.thumbnailToken, getFileUrl]);

    return (
        <div
            className={`bg-white border rounded-lg shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden ${isSelected
                    ? "border-[#047857]"
                    : "border-gray-200 hover:border-[#047857]"
                }`}
            onClick={() => onSelect(viewpoint.id)}
        >
            <div className="relative">
                {loading ? (
                    <div className="w-full aspect-video bg-gray-200 animate-pulse" />
                ) : thumbnailUrl ? (
                    <img
                        src={thumbnailUrl}
                        alt={viewpoint.module}
                        className="w-full aspect-video object-cover"
                    />
                ) : (
                    <div className="w-full aspect-video bg-gray-300 flex items-center justify-center">
                        <span className="text-xs text-gray-500">No image</span>
                    </div>
                )}
            </div>

            <div className="p-3 text-center">
                <span className="inline-flex items-center bg-emerald-50 border border-emerald-200 text-emerald-800 text-xs font-medium px-2 py-1 rounded-md mb-2">
                    <svg className="w-3 h-3 me-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    {viewpoint.module}
                </span>
                <h5 className="mt-2 text-sm font-semibold text-gray-900 truncate">
                    {viewpoint.filename}
                </h5>
            </div>
        </div>
    );
});

CameraViewpoint.displayName = "CameraViewpoint";
